import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/e2392d86-5e6f-4ec0-a955-bc32fe7e85b8";
export const REGISTER_URL = "https://a.ntrk2.com/2237093c-9be6-4ae6-a7c2-6456deb68ba2";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowco.kzw2a.com/download?openExternalBrowser=1&id=98w9tytrrm3yyrm";

export * from "./codes";
export * from "./context";
